import React from 'react';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import { useDispatch } from "react-redux"
import AppsApi from "../../../../Resources/Organization/Apps/AppsApi.js"
import { trackButtonClicked } from "../../../Services/Analytics/TrackEventsService.js"
import { GIFT_UP } from "../AppsData.js"

const GiftUpButton = () => {
  const dispatch = useDispatch()

  const submitSignUp = () => {
    AppsApi.updateApp(GIFT_UP, { enabled: true })
    window.open(
      'https://giftup.app/account/register?fpr=hcp&promo=HOUSECALLPRO&utm_source=housecallpro',
      '_blank'
    )
  }

  const properties = {
    app_name: 'gift_up',
    category: 'interest',
    pathname: window.location.pathname,
    url: window.location.href
  }

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        submitSignUp()
        dispatch(trackButtonClicked('gift_up', properties))
      }}
    >
      Get started
    </Button>
  )
}
export default GiftUpButton
